<template>
  <svg viewBox="82.033 30.55 128 128" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_1">
      <circle class="st0" cx="145.869" cy="94.332" r="63.776" style="stroke: rgba(255, 255, 255, 0.58); fill: rgba(0, 0, 0, 0.07);"/>
      <path d="M 152.633 77.9 L 152.633 83.3 L 166.283 75.35 L 171.683 81.95 C 170.883 85.95 168.233 89.25 163.733 91.85 L 159.083 94.55 L 172.883 102.35 L 169.733 110.3 C 168.333 110.8 166.607 111.05 164.553 111.05 C 162.507 111.05 160.033 110.2 157.133 108.5 L 152.633 105.95 L 152.633 121.85 L 144.233 123.05 C 141.033 120.35 139.433 116.4 139.433 111.2 L 139.433 105.95 L 125.633 113.9 L 120.383 107.3 C 121.183 103.2 123.833 99.85 128.333 97.25 L 132.983 94.55 L 119.183 86.45 L 122.183 78.65 C 123.483 78.15 125.157 77.9 127.203 77.9 C 129.257 77.9 131.783 78.8 134.783 80.6 L 139.433 83.3 L 139.433 67.25 L 147.833 66.05 C 151.033 68.65 152.633 72.6 152.633 77.9 Z" style="fill: rgb(229, 229, 229); white-space: pre;"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "asterix-circle-icon"
}
</script>

<style scoped>

</style>